// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"5548":"calendar","7195":"single-collections","8491":"pulse","8620":"collections","9064":"crates"}[chunkId] || chunkId) + "." + {"5548":"efcd5f69","7195":"3919c7cc","8491":"45bc706c","8620":"679908f0","9064":"89c12011","9478":"05f37fae","9602":"f805873f"}[chunkId] + ".css";
};